import { BCard } from 'bootstrap-vue'
import { TEST_SLEEP_QUALITY, TEST_PHYSICAL_ACTIVITY, TEST_PSYCHOSOCIAL_RISKS, TEST_RYFF_SCALE, TEST_CARDIOVASCULAR_RISK, TEST_FINDRISK, TEST_MEDITERRANEAN_DIET, TEST_ANXIETY_BECK, TEST_NICOTINE_DEPENDENCY, TEST_GENERAL_HEALTH, TEST_INTERPERSONAL_RELATIONSHIPS, TEST_SOCIAL_SKILLS, TEST_WORK_ENVIRONMENT } from '@/constants/patientServices'
import { formatDateByMonthLong } from '@/helpers/date.helpers'
import { GREEN_COLOUR, RED_COLOUR, YELLOW_COLOUR, ORANGE_MID_COLOUR, GREEN_LIGHT_COLOUR } from '@/constants/colours'
import { mapState } from 'vuex'
import { testRoute } from '@/helpers/tests.helpers'
import QuestionCard from '@/components/utils/QuestionCard.vue'

export default {
    components: {
        BCard,
        'loading-anim': () => import('@/components/utils/LoadingAnim'),
        QuestionCard
    },
    data () {
        return {
            date: new Date()
        }
    },
    methods: {
        calculateMultidimensionalDimPoints (dimension) {
            let sum = 0
            let total = 0
            for (let question of dimension.questions) {
                let val1 = question.answer[0].value
                let val2 = question.answer[question.answer.length - 1].value
                let ans = question.result !== null && this.opposedAnswers && this.opposedAnswers.includes(question.id) ? val1 + val2 - question.result : question.result
                sum = sum + ans
                total = total + Math.max(val1, val2)
            }
            return {sum: sum, total: total}
        },
        percentResult (r, totalPoints) {
            return Math.round(r * 100 / totalPoints)
        },
        save (dimensions, result, percentage = null) {
            this.$store.dispatch('tests/saveTestResult', {dimensions: dimensions, result: result, percentage: percentage || result, date: this.date, testId: this.testId, testName: this.testName, userId: this.$store.state.session.user.id})
            this.testResultsInfo(this.testId)
        },
        testResultsInfo (testId, graphResult) {
            var result  = graphResult != null ? graphResult : this.DBResults.generalResult
            var resultInfo = {}
            switch (testId) {
                case TEST_ANXIETY_BECK:
                    resultInfo = {
                        tag: result <= 21 ? this.$t('tests.anxiety-beck.lowAnxiety') : result <= 35 ? this.$t('tests.anxiety-beck.moderateAnxiety') : this.$t('tests.anxiety-beck.severeAnxiety'),
                        color: result <= 21 ? GREEN_COLOUR : result <= 35 ? YELLOW_COLOUR : RED_COLOUR
                    }
                    break
                case TEST_CARDIOVASCULAR_RISK:
                    switch (true) {
                        case result < 10:
                            resultInfo = { risk: 'lowRisk', tag: this.$t(`tests.cardiovascular-risk.scores.lowRisk.name`), color: GREEN_COLOUR }
                            break
                        case result >= 10 && result <= 20:
                            resultInfo = { risk: 'midRisk', tag: this.$t(`tests.cardiovascular-risk.scores.midRisk.name`), color: YELLOW_COLOUR }
                            break
                        case result > 20:
                            resultInfo = { risk: 'highRisk', tag: this.$t(`tests.cardiovascular-risk.scores.highRisk.name`), color: RED_COLOUR }
                            break
                    }
                    break
                case TEST_FINDRISK:
                    switch (true) {
                        case result < 7:
                            resultInfo = {tag: this.$t('tests.findrisk.scores.lowRisk'), color: GREEN_COLOUR}
                            break
                        case result >= 7 && result <= 11:
                            resultInfo = {tag: this.$t('tests.findrisk.scores.lightRisk'), color: GREEN_LIGHT_COLOUR}
                            break
                        case result >= 12 && result <= 14:
                            resultInfo = {tag: this.$t('tests.findrisk.scores.moderateRisk'), color: YELLOW_COLOUR}
                            break
                        case result >= 15 && result <= 20:
                            resultInfo = {tag: this.$t('tests.findrisk.scores.highRisk'), color: RED_COLOUR}
                            break
                        case result > 20:
                            resultInfo = {tag: this.$t('tests.findrisk.scores.veryHighRisk'), color: RED_COLOUR}
                            break
                    }
                    break
                case TEST_INTERPERSONAL_RELATIONSHIPS:
                    switch (true) {
                        case result <= 70:
                            resultInfo = {tag: this.$t('tests.interpersonal-relationships.scores.lowScore.score'), description: this.$t('tests.interpersonal-relationships.scores.lowScore.description'), color: RED_COLOUR}
                            break
                        case result <= 105:
                            resultInfo = {tag: this.$t('tests.interpersonal-relationships.scores.mid-lowScore.score'), description: this.$t('tests.interpersonal-relationships.scores.mid-lowScore.description'), color: ORANGE_MID_COLOUR}
                            break
                        case result <= 140:
                            resultInfo = {tag: this.$t('tests.interpersonal-relationships.scores.midScore.score'), description: this.$t('tests.interpersonal-relationships.scores.midScore.description'), color: YELLOW_COLOUR}
                            break
                        case result <= 160:
                            resultInfo = {tag: this.$t('tests.interpersonal-relationships.scores.mid-highScore.score'), description: this.$t('tests.interpersonal-relationships.scores.mid-highScore.description'), color: GREEN_LIGHT_COLOUR}
                            break
                        case result >= 161:
                            resultInfo = {tag: this.$t('tests.interpersonal-relationships.scores.highScore.score'), description: this.$t('tests.interpersonal-relationships.scores.highScore.description'), color: GREEN_COLOUR}
                            break
                    }
                    break
                case TEST_SOCIAL_SKILLS:
                    switch (true) {
                        case result <= 66:
                            resultInfo = {tag: this.$t('tests.social-skills.scores.lowScore.score'), description: this.$t('tests.social-skills.scores.lowScore.description'), color: RED_COLOUR}
                            break
                        case result <= 99:
                            resultInfo = {tag: this.$t('tests.social-skills.scores.mid-lowScore.score'), description: this.$t('tests.social-skills.scores.mid-lowScore.description'), color: ORANGE_MID_COLOUR}
                            break
                        case result <= 132:
                            resultInfo = {tag: this.$t('tests.social-skills.scores.midScore.score'), description: this.$t('tests.social-skills.scores.midScore.description'), color: YELLOW_COLOUR}
                            break
                        case result <= 149:
                            resultInfo = {tag: this.$t('tests.social-skills.scores.mid-highScore.score'), description: this.$t('tests.social-skills.scores.mid-highScore.description'), color: GREEN_LIGHT_COLOUR}
                            break
                        case result >= 150:
                            resultInfo = {tag: this.$t('tests.social-skills.scores.highScore.score'), description: this.$t('tests.social-skills.scores.highScore.description'), color: GREEN_COLOUR}
                            break
                    }
                    break
                case TEST_MEDITERRANEAN_DIET:
                    let proCon = ['heartDiseasesRisk', 'diabetesRisk', 'cancerRisk', 'cognitiveFunction', 'mentalHealth']
                    var listOfProCon = []
                    if (result < 8) {
                        resultInfo = {
                            tag: this.$t('tests.mediterranean-diet.scores.lowAdherence.name'),
                            color: RED_COLOUR,
                            resultsAnalysis: this.$t('tests.mediterranean-diet.scores.lowAdherence.description'),
                            prosCons: 'consequences'
                        }
                    } else {
                        resultInfo = {
                            tag: this.$t('tests.mediterranean-diet.scores.goodAdherence.name'),
                            color: GREEN_COLOUR,
                            resultsAnalysis: this.$t('tests.mediterranean-diet.scores.goodAdherence.description'),
                            prosCons: 'benefits'
                        }
                    }
                    for (let p of proCon) {
                        listOfProCon.push({ id: p, name: this.$t(`tests.mediterranean-diet.${resultInfo.prosCons}.${p}.name`), description: this.$t(`tests.mediterranean-diet.${resultInfo.prosCons}.${p}.description`) })
                    }
                    this.$set(resultInfo, 'listOfProCon', listOfProCon)
                    break
                case TEST_NICOTINE_DEPENDENCY:
                    let t = []
                    var tips = []
                    switch (true) {
                        case result === 0:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.noDependency.name'),
                                color: GREEN_COLOUR,
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.noDependency.description')
                            }
                            break
                        case result < 12:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.lowDependency.name'),
                                color: GREEN_COLOUR,
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.lowDependency.description')
                            }
                            t = ['conscious', 'endDate', 'reduceDaily', 'forgetTheHabit', 'lookForSupport']
                            break
                        case result >= 12 && result <= 22:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.midDependency.name'),
                                color: YELLOW_COLOUR,
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.midDependency.description')
                            }
                            t = ['motivation', 'causes', 'endDate', 'forgetTheHabit', 'relaxTechniques', 'rewards']
                            break
                        case result >= 22 && result <= 33:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.highDependency.name'),
                                color: RED_COLOUR,
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.highDependency.description')
                            }
                            t = ['motivation', 'causes', 'endDate', 'forgetTheHabit', 'relaxTechniques', 'rewards', 'rememberBenefits', 'healthyLifestyle']
                            break
                        case result > 33:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.veryHighDependency.name'),
                                color: RED_COLOUR,
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.veryHighDependency.description')
                            }
                            t = ['motivation', 'causes', 'endDate', 'forgetTheHabit', 'relaxTechniques', 'rewards', 'rememberBenefits', 'healthyLifestyle']
                            break
                    }
                    for (let tip of t) {
                        tips.push({ name: this.$t(`tests.nicotine-dependency.tips.${tip}.name`), description: this.$t(`tests.nicotine-dependency.tips.${tip}.description`) })
                    }
                    this.$set(resultInfo, 'tips', tips)
                    break
                case TEST_PHYSICAL_ACTIVITY:
                    if (this.testResultLayout(TEST_PHYSICAL_ACTIVITY)) {
                        var testResult = this.$store.state.tests.DBResults
                        if (testResult.generalResult >= 3000 || (testResult.generalResult >= 1500 && testResult.dimensions[0].result >= 3)) {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.highLevel'),
                                color: GREEN_COLOUR,
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.high')
                            }
                        } else if (testResult.generalResult >= 600 || (testResult.dimensions[0].result >= 3 && testResult.dimensions[1].result >= 20) || (testResult.dimensions[2].result + testResult.dimensions[4].result >= 5 && testResult.dimensions[3].result + testResult.dimensions[5].result >= 30)) {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.moderateLevel'),
                                color: YELLOW_COLOUR,
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.moderate')
                            }
                        } else {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.lowLevel'),
                                color: RED_COLOUR,
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.low')
                            }
                        }
                    } else {
                        if (result === 100) {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.highLevel'),
                                color: GREEN_COLOUR,
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.high')
                            }
                        } else if (result === 50) {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.moderateLevel'),
                                color: YELLOW_COLOUR,
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.moderate')
                            }
                        } else {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.lowLevel'),
                                color: RED_COLOUR,
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.low')
                            }
                        }
                    }
                    
                    break
                case TEST_RYFF_SCALE:
                    var color = result < 50 ? RED_COLOUR : result < 70 ? YELLOW_COLOUR : GREEN_COLOUR
                    var resultAnalysis = ''
                    if(this.testResultLayout(TEST_RYFF_SCALE)) {
                        const previousResults = this.$store.state.tests.previousTestResults
                        if (previousResults.length === 1) {
                            resultAnalysis = this.$t('tests.ryff-scale.resultsAnalysisFirstTime')
                        } else {
                            const thisMonthResult = previousResults[previousResults.length - 1].generalResult
                            const lastMonthResult = previousResults[previousResults.length - 2].generalResult
        
                            resultAnalysis = thisMonthResult >= lastMonthResult + 5 ? this.$t('tests.ryff-scale.resultsAnalysisGood')
                                : thisMonthResult <= lastMonthResult - 5 ? this.$t('tests.ryff-scale.resultsAnalysisBad')
                                : this.$t('tests.ryff-scale.resultsAnalysisMedium')
                        }
                    }
                    resultInfo = { resultAnalysis: resultAnalysis, color: color }
                    break
            }
            this.$store.commit('tests/setResultInfo', resultInfo)
            return resultInfo
        },
        testResultLayout (testId) {
            var t = testId.replace('Test ', '').toLocaleLowerCase().replace(' ', '-')
            var alias = testRoute(t)
            return this.$route.path.includes(t) || this.$route.path.includes(alias)
        },
        randomizeTest () {
            var test = [...this.test]
            switch (this.testId) {
                //flatten dimensions and randomize
                case TEST_PSYCHOSOCIAL_RISKS:
                case TEST_RYFF_SCALE:
                case TEST_WORK_ENVIRONMENT:
                case TEST_GENERAL_HEALTH:
                    test = test.flatMap(x => x.questions).sort(() => Math.random() - 0.5)
                    break
                //flatten dimensions without randomize
                case TEST_SLEEP_QUALITY:
                    test = test.flatMap(x => x.questions).sort()
                    break
                //return test without reorder
                case TEST_PHYSICAL_ACTIVITY:
                    test = test.sort()
                    break
                //randomize test
                default:
                    test.sort(() => Math.random() - 0.5)
                    break
            }
            return test
        }
    },
    computed: {
        cQ: {
            get () {
                return this.$store.state.tests.test[this.$store.state.tests.currentSlide]
            }
        },
        questionResult: {
            get () {
                return this.cQ ? this.cQ.result : null
            },
            set (newValue) {
                const selectedAnswer = this.cQ.answer.find(x => x.value === newValue)
                this.$set(this.cQ, 'resultText', selectedAnswer.text)
                this.$set(this.cQ, 'result', newValue)
            }
        },
        month () {
            return formatDateByMonthLong(new Date(this.DBResults.date))
        },
        testRoute () {
            return this.testId.replace('Test ', '').toLocaleLowerCase().replace(' ', '-')
        },
        ...mapState('tests', ['resultInfo', 'DBResults'])
    }
}


// WEBPACK FOOTER //
// ./src/mixins/selfEvaluationTest.mixin.js